import endpoints from '@/endpoints';
import { http } from '@/utils/HttpClient';

export type DownloadSuccessReportPayload = {
  userId?: string;
  userUniqueId?: string;
  processId: string;
  premium?: boolean;
  platform: 'web' | 'mobile';
  userSource?: string;
  modelName?: string;
  eventName: string;
  credit?: number;
  data?: string;
  activityType?: string;
};

export const downloadSuccessService = {
  reportDownloadSuccess(payload: DownloadSuccessReportPayload) {
    return http.fetch({
      method: endpoints.download.reportDownloadSuccess.method,
      endpoint: endpoints.download.reportDownloadSuccess.url(),
      config: {
        body: payload,
      },
    });
  },
};

